export default __webpack_public_path__ + "static/zaru_collages_v6-16-a6602392cf2e4ccc129ab680dee2155a.png";